export type PremiumContentWithCustomString = PREMIUM_CONTENT | string

export enum PREMIUM_CONTENT {
  BRAINEE = 'BRAINEE',
  POSHURSHEMO = 'POSHURSHEMO',
  ATAIRU = 'ATAIRU',
  BLENDED_CARE = 'BLENDED_CARE',
  WEBINARS = 'WEBINARS',
  WEBINARS_UPCOMING = 'WEBINARS_UPCOMING',
  SHORT_VIDEOS = 'SHORT_VIDEOS',
}
